
<template>
    <LandingPage>
      <template slot="taption_header">
        <div id="text1-strings">
           <p>ビデオに字幕を簡単に追加</p>
           <p>簡単な AI ビデオ分析</p>
           <p>簡単なビデオ翻訳</p>
           <p>ビデオをテキストに簡単に変換</p>
         </div>
         <span id="text1"></span>
      </template>
      <template slot="landing_description">AI が自動的に字幕、翻訳、テキスト、分析変換をサポート<br>40以上の言語をサポート</template>

      <template slot="intro_video">
          <!-- <video playsinline class="intro-video" src="https://firebasestorage.googleapis.com/v0/b/taption-production-taiwan/o/system%2Fch_crop_com.mp4?alt=media&token=7bd7d213-cf0e-4d4b-8cc7-d3506594caa1" autoplay frameborder="0" height="350" width="575" muted></video> -->
          <video playsinline class="intro-video" :src='"@/assets/video/landing_en.mp4"' autoplay frameborder="0" height="350" width="575" muted></video>
          
      </template>

      <template slot="start_your_trial">15分間サインアップ!</template>

      <!-- <template slot="as_seen_on"><h1>メディア報道</h1></template> -->
      <template slot="use_case_title">素晴らしいプラットフォーム</template>

<template slot="youtubers">テキストに変換して字幕を追加</template>
<template slot="youtubers_question">音声ファイルを自動的にテキストに変換し、<span style="color:#00d1b2;">単一またはバイリンガルの字幕を追加</span>します。</template>

<template slot="journalists">AI分析</template>
<template slot="journalists_question">AIが要約、タイトルを付け、ビデオ固有の<span style="color:#00d1b2;">ChatGPT</span>を提供します。</template>
      <!-- <template slot="youtubers">動画をテキストに変換</template>
      <template slot="youtubers_question">デバイスやYouTube、Google Drive、Zoomからの動画に自動的に字幕挿入</template>
      <template slot="journalists">ビデオに字幕を挿入</template>
      <template slot="journalists_question">動画に多国語字幕を自動生成</template> -->

      
      

      <template slot="translators">動画翻訳</template>
<template slot="translators_question"><span style="color:#00d1b2;">50言語以上</span>の自動動画翻訳に対応</template>
<template slot="speaker">話者識別</template>
<template slot="speaker_question">会議録、音声ファイル、Podcastなどの自動話者識別</template>

<template slot="timealign">テキストのタイムコード付け</template>
<template slot="timealign_question">提供されたテキストにタイムコードと話者タグを追加</template>

<template slot="audiotomp4">音声ファイルを動画に変換</template>
<template slot="audiotomp4_question">音声を文字起こし、画像を追加し字幕付き動画を作成</template>

<template slot="importsrt">TXTまたはSRT字幕の編集</template>
<template slot="importsrt_question">自動で文字に時間軸を追加、またはSRT字幕ファイルを提供し校正</template>

<template slot="share">企業向け機能とセキュリティ</template>
<template slot="share_question">カスタム権限、分数共有、共同編集で効率的な管理</template>

<template slot="learnmore">詳細を見る</template>

<template slot="simple_workflow">簡単なワークフロー。</template>

<template slot="upload">アップロード</template>
<template slot="upload_description">動画をTaptionにアップロード、YouTubeダウンロード、WebexダウンロードやZoomダウンロード、Google Driveからも可能。多様な形式に対応し、音声を素早く正確にテキスト化します。</template>

<!-- <template slot="transcribe">文字起こし・字幕挿入Transcribe</template>

<template slot="transcribe_description">私たちは40か国語以上の言語で字幕挿入をサポートします</template> -->

<template slot="edit_translate">編集</template>

<template slot="edit_translate_description">ビデオ文字起こしオンライン編集プラットフォームでは、テキストが自動的にタイムラインと同期。テキスト編集、字幕分割、ビデオ編集も手動で時間調整する必要なし！</template>

<template slot="transcribe">AI分析</template>

<template slot="transcribe_description">ビデオに関する質問や指示をAIが分析。専用のChatGPTのように機能！ビデオ要約や要点抽出が迅速に行え、核心コンテンツを簡単に把握できます。</template>

<template slot="translate">翻訳</template>

<template slot="translate_description">オンライン翻訳ソフトで、従来の自動翻訳の字幕非同期や直訳問題を解決。40以上の言語に対応し、中国語⇔英語、日本語翻訳、韓国語翻訳、ベトナム語翻訳など。</template>

<template slot="export">エクスポート</template>

<template slot="export_description">字幕編集とビデオ編集後、多様なフォーマットでエクスポート可能（単言語/二カ国語字幕入りMP4、SRT、VTT、PDF、TXT）。</template>

<template slot="try_it_now">今すぐ試す！</template>
      


            <template slot="editing_platform_desc1">下部のタイムラインでビデオを簡単にトリミング・カット。編集中に字幕と重なる場合、テキストを自動削除し時間を調整し、ビデオと字幕の一貫性を保持します。迅速な編集に適しており、プロフェッショナルな成果を簡単に実現します。</template>
      <template slot="video_time_stampped">
            <div class="video-wrapper" @click="onClicked('video1', true)">
                  <div class="play-button" v-show="!videoState.video1">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
                  <video id="video1" ref="video1" playsinline preload="none" class="unique-video" poster="../assets/images/thumbnail/cut_thumbnail_en.webp" :src='"@/assets/video/Trim_Cut_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
      </template> 
      
       <template slot="editing_platform">強力な編集プラットフォーム</template>
      <template slot="editing_platform_desc0">字幕を削除することで簡単にビデオをトリミングできます。テキストを編集するとビデオの長さが自動的に調整され、シームレスな結果が保証されます。迅速かつ正確な編集に最適で、ビデオ編集プロセスを簡素化し、労力をかけずに洗練された成果を実現します。</template>
      <template slot="video_trimmed">
            <div class="video-wrapper" @click="onClicked('video0', true)">
                  <div class="play-button" v-show="!videoState.video0">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
          <video id="video0" ref="video0" playsinline preload="none" poster="../assets/images/thumbnail/trim_thumbnail_en_US.webp" class="intro-video" :src='"@/assets/video/Trim_English.mp4"' frameborder="0" height="350" width="575" muted></video>
            </div>
      </template>
      <template slot="editing_platform_desc2">「AI分析」機能は、アップロードされた動画を深く分析し、要約、ポイント抽出、内容検索、質問応答をサポートし、動画の理解と対話効率を向上させます。さらに、YouTubeチャプター生成、タイトル自動作成、誤字自動修正など、便利なテンプレートを提供し、動画分析・編集プロセスを簡素化します。</template>
      <template slot="video_replace_all">
          <div class="video-wrapper" @click="onClicked('video2', true)">
              <div class="play-button" v-show="!videoState.video2">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video2" ref="video2" playsinline preload="none" poster="../assets/images/thumbnail/analysis_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/AI_Analysis_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
      <template slot="editing_platform_desc3">このMP4ファイルは「メモ機能」を紹介しています。ビデオの特定の箇所にコメントやメモを残すことができ、簡単に参照も可能です。効率的な情報管理をサポートします。</template>
      <template slot="video_add_dictionary">
        <div class="video-wrapper" @click="onClicked('video3', true)">
              <div class="play-button" v-show="!videoState.video3">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video3" ref="video3" playsinline preload="none" poster="../assets/images/thumbnail/memo_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/Memo_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
      
      <template slot="low_cost">手頃な価格</template>
      <template slot="title_basic">映画の長さの料金</template>
      <template slot="basic_cost_usd">$8</template>
      <template slot="basic_cost_ntd">(1170 JPY)</template>
      <template slot="unit">ドル</template>
      <template slot="hour">時間</template>
      <template slot="basic_feature5">補充<span style="color: #00d1b2;">60分</span></template>
      <template slot="basic_feature1">動画ファイルをテキストに自動変換</template>
      <template slot="basic_feature2">40以上の言語をサポート</template>
      <template slot="basic_feature3">正確な時間比較エディタ</template>
      <template slot="basic_feature4">50 以上の言語に翻訳</template>
      <template slot="basic_feature7">パーソナル AI 辞書</template>
      <template slot="basic_feature6">商用利用可能</template>
      <template slot="basic_feature8">ビデオ エクスポートに埋め込まれたバイリンガルの字幕</template>

      <template slot="title_premium">プレミアムサブスクリプション</template>
      <template slot="premium_cost_usd">$12</template>
      <template slot="premium_cost_ntd">(1755 JPY)</template>
      <template slot="premium_basic_cost_usd">6 USD</template>
      <template slot="month">月</template>

      <template slot="premium_before"><span class="landing-arrow-left">&#10229;</span>すべての「動画の長さの料金設定」機能</template>
      <template slot="premium_feature1">毎月プレゼント<span style="color: #00d1b2;">120分</span> <br><span style="color:#797676;font-size:14px;font-weight: 100;">(月をまたいで累積可能、サブスクリプションがキャンセルされるまで有効)</span></template>
      <template slot="premium_feature1_tooltip">この分は、サブスクリプションがキャンセルされるまで蓄積され続ける可能性があります. <br>この分は、別途購入した分よりも優先して使用されます。 <br>追加購入した分は、退会しても失われません。 </template>
      <template slot="premium_feature2">さらに数分間、25% オフ</template>
      <template slot="premium_feature3">ビデオに埋め込まれた字幕は分数を差し引かず、無制限にエクスポート</template>
      <template slot="premium_feature4">編集のために他のユーザーと共有</template>
      <template slot="premium_feature5">字幕付きビデオへの録画</template>
      <template slot="premium_feature6">ビデオクリップ (字幕自動調整)</template>
      

      <template slot="title_corp">大きいサブスクリプション</template>
      <template slot="bulk_cost_usd">$69</template>
      <template slot="bulk_cost_ntd">(10090 JPY)</template>
      <template slot="bulk_basic_cost_usd">4 USD</template>
      <template slot="bulk_before"><span class="landing-arrow-left">&#10229;</span>すべての「ビデオの長さの価格設定」と「プレミアムサブスクリプション」機能</template>
       <template slot="bulk_feature2">さらに数分、3.3% オフで購入</template>
      <template slot="premium_feature1_bulk">毎月プレゼント<span style="color: #00d1b2;">1000分</span> <br><span style="color:#797676;font-size:14px;font-weight: 100;">(月をまたいで累積可能、サブスクリプションがキャンセルされるまで有効)</span></template>
      <template slot="bulk_feature1">社名・背番号入り請求書ダウンロード</template>
       <template slot="bulk_feature3">ユーザーに参加して議事録を共有し</template>
       <template slot="bulk_feature4">参加ユーザーに6種類の権限管理を提供</template>

      <template slot="go_to_price">もっと理解する</template>
    </LandingPage>
</template>

<script>
import LandingPage from "./LandingPage";

export default {
  data: () => ({
      videoState:{
          video0:false,
          video1:false,
          video2:false,
          video3:false  
      }
  }),
  components: {
    LandingPage
  },
  methods: {
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    }
  },
  mounted(){
    const me = this;
    const video0 = document.getElementById("video0");  
    const video1 = document.getElementById("video1");   
    const video2 = document.getElementById("video2");   
    const video3 = document.getElementById("video3");   


    if(video0){
        video0.onended = function() {
            me.videoState.video0 = false;
        }
        // video0.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video0 = false;
        // } 
    }


    if(video1){
        video1.onended = function() {
            me.videoState.video1 = false;
        }
        // video1.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video1 = false;
        // } 
    }


    if(video2){
        video2.onended = function() {
            me.videoState.video2 = false;
        } 
        // video2.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video2 = false;
        // } 
    }

    if(video3){
        video3.onended = function() {
            me.videoState.video3 = false;
        } 
        // video3.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video3 = false;
        // } 
    }
  }
}

</script>


           